import { ALL_DEPARTURE_TIMES } from '../helpers/constants/departureTimeConstants';

import type { DepartureTimeFilterState } from './types';
import type { DepartureTime } from '../helpers/constants/departureTimeConstants';

const isBucketIncluded = (
  state: DepartureTimeFilterState,
  bucket: DepartureTime,
) => !!state[bucket];

const getDepartureTimesSelected = (
  state: DepartureTimeFilterState,
): DepartureTime[] => ALL_DEPARTURE_TIMES.filter((bucket) => state[bucket]);

export default { isBucketIncluded, getDepartureTimesSelected };
